import React from "react";
import './css/LoadingSpinner.css'; // We'll create this CSS file

export const LoadingSpinner = ({ 
    message = "Loading...", 
    size = "w-16 h-16",
    className = "",
    animationType = "dynamic-spin" // Options: dynamic-spin, elastic-spin, pulsing-spin, wobble-spin, custom-easing-spin
}) => {
    return (
        <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${className} font-nunito`}>
            <div className="bg-white rounded-lg p-8 flex flex-col items-center space-y-4 shadow-xl">
                <div className={`${size} border-4 border-gray-200 border-t-blue-600 rounded-full ${animationType}`}></div>
                {message && (
                    <p className="text-gray-700 font-medium text-center">{message}</p>
                )}
            </div>
        </div>
    );
};